var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-circle-notch fa-spin mr-1"}),_vm._t("default",[_vm._v("Carregando…")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }